import React, { useState, useEffect, useCallback } from 'react';
import { format, parse, addDays } from 'date-fns';
import { Header, Paragraph, Section, Form } from '../components/Typography';
import TextInput from '../components/TextInput';
import Button from '../components/Button';
import Select from '../components/Select';
import TermsOfService from '../components/termsOfService/TermsOfService';

const dateFormat = 'yyyy-MM-dd';

const internationalDateFormat = 'dd-MMM-yyyy';

const formatStartDate = date =>
  format(parse(date, dateFormat, new Date()), internationalDateFormat);

const formatEndDate = date =>
  format(
    addDays(parse(date, dateFormat, new Date()), 14),
    internationalDateFormat
  );

const NameForm = ({
  api,
  confirmEmailCode,
  onSubmit,
  onInvalidConfirmEmailCode,
}) => {
  const [attendee, setAttendee] = useState();
  const [name, setName] = useState('');
  const [course, setCourse] = useState();
  const [courses, setCourses] = useState([]);
  const [acceptedTOS, setAcceptedTOS] = useState(false);

  const loading = !course || !attendee;

  const confirmEmailAndGetCourses = useCallback(async () => {
    const [attendee, courses] = await Promise.all([
      api.getAttendeeFromConfirmEmailCode(confirmEmailCode),
      api.getCourses(),
    ]);
    const [defaultCourse] = courses;

    setCourses(courses);
    setCourse(defaultCourse);
    setAttendee(attendee);

    if (!attendee || !attendee.id) {
      onInvalidConfirmEmailCode();
    }
  }, [confirmEmailCode, onInvalidConfirmEmailCode, api]);

  useEffect(() => {
    confirmEmailAndGetCourses();
  }, [confirmEmailAndGetCourses]);

  const handleChangeName = e => {
    const value = e.target.value || '';
    setName(value);
  };

  const handleSelect = course => setCourse(course);

  const handleSetAcceptedTOS = acceptedTOS => setAcceptedTOS(acceptedTOS);

  const handleSubmit = async e => {
    e.preventDefault();
    const { id } = attendee;
    await api.registerCourse({ id, name, courseId: course.id });
    onSubmit();
  };

  return (
    <>
      <Section>
        <Header>AI trainer onboarding sign-up form.</Header>
        <Paragraph>
          <strong>
            You’re one step away from starting on your journey to become an AI
            trainer.
          </strong>
        </Paragraph>
        <Paragraph>
          Enter your full name, and select a start date to begin your
          onboarding. You will get 14 days of access in which you're supposed to
          complete your training.
        </Paragraph>
        <Paragraph>
          This time period is to ensure that you have a deadline, and we know
          from experience that it is plenty of time to finish. Our full
          onboarding takes on average 1 full day of work to complete, so we
          recommend you choose a starting date where you are confident that you
          have time to finish 8 hours of training within 14 days.
        </Paragraph>
      </Section>
      <Form onSubmit={handleSubmit}>
        <label htmlFor="certiself-name">Full name</label>
        <TextInput
          type="text"
          name="certiself-name"
          id="certiself-name"
          onChange={handleChangeName}
          value={name}
          required
        />
        <Select
          isSearchable={false}
          options={courses}
          getOptionLabel={({ startDate }) =>
            `${formatStartDate(startDate)} to ${formatEndDate(startDate)}`
          }
          getOptionValue={({ id }) => id}
          value={course}
          onChange={handleSelect}
          disabled={loading}
          placeholder="No available courses"
        />
        <TermsOfService
          acceptedTOS={acceptedTOS}
          onSetAcceptedTOS={handleSetAcceptedTOS}
        />
        <Button type="submit" disabled={loading || !acceptedTOS}>
          SUBMIT
        </Button>
      </Form>
    </>
  );
};

export default NameForm;
